import * as types from './mutation-types'

export default {
  [types.SET_CATEGORIES_PRODUTOS] (state, payload) {
    state.categories_produtos = payload
  },
  
  [types.SET_PRODUTOS_BY_CATEGORIE] (state, payload) {
    state.product_by_categorie = payload
  },
  [types.SET_QUANTITY_PRODUTOS_BY_CATEGORIE] (state, payload) {
    state.quantity_product_by_categorie = payload
  },
  [types.SET_CHOICED_PRODUCT] (state, payload) {
    state.choiced_product = payload
  },
  [types.GET_PRODUTO] (state, payload) {
    state.get_product = payload
  }
}
